import {MapRef} from 'react-map-gl';
import {MarkerProps} from 'components/BaseMap';
import {LocationType} from 'components/BaseMap/Marker/MarkerIcon';
import {Coords, Location} from 'components/TimePicker/types';

type CreateProps = {
	setSelected: (selected: Location | null) => void
	selected: Location | null
	mapRef: React.RefObject<MapRef>
}

export const userMarkerId = '<user>';

// Helper functions we use to create markers from locations
export const createMarker = ({
	setSelected,
	selected,
	mapRef,
}: CreateProps) => {
	return (loc: Location): MarkerProps => ({
		id: loc.id,
		latitude: loc.details.coords.lat,
		longitude: loc.details.coords.lng,
		type: loc.details.isStore ?
			LocationType.store :
			LocationType.van,

		onClick: () => {
			setSelected(selected?.id === loc.id ? null : loc);
			if (mapRef.current) {
				mapRef.current.flyTo({
					center: [
						loc.details.coords.lng,
						loc.details.coords.lat,
					]
				});
			}
		},
	});
};

export const createUserMarker = (
	create: CreateProps,
	coords: Coords,
): MarkerProps => {
	const {setSelected, selected, mapRef} = create;

	return ({
		id: userMarkerId,
		longitude: coords.lng,
		latitude: coords.lat,
		type: LocationType.user,
		style: {zIndex: 1},
		onClick: () => {
			setSelected(
				selected?.id === userMarkerId ? null : {
					id: userMarkerId,
				} as Location
			);

			if (mapRef.current) {
				mapRef.current.flyTo({
					center: [
						coords.lng,
						coords.lat,
					]
				});
			}
		},
	});
};
